// src/utils/emailService.js
import emailjs from "@emailjs/browser";

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const USER_ID = process.env.REACT_APP_EMAILJS_USER_ID;

/**
 * Sends a support request email via EmailJS.
 *
 * @param {Object} params
 * @param {string} params.name              – sender’s name (will go in `to_name`)
 * @param {string} params.fromEmail         – sender’s email (will go in `from_email`)
 * @param {string} params.organization      – organization name
 * @param {string} params.queryType         – e.g. "Technical Support"
 * @param {string} params.queryDescription  – the body of your issue
 * @param {string} params.priority          – e.g. "Important" or "Normal"
 * @returns {Promise}                       – resolves on success, rejects on failure
 */
export function sendSupportEmail({
  name,
  fromEmail,
  organization,
  queryType,
  queryDescription,
  priority,
}) {
  const templateParams = {
    to_name: name,
    to_email: "support@queryloop.ai",
    organization,
    query_type: queryType,
    query_description: queryDescription,
    email_priority: priority,
    from_name: "QueryLoop Support",
    from_email: fromEmail,
  };

  return emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, USER_ID);
}

export async function sendSupportRequest({
  name,
  fromEmail,
  organization,
  queryType,
  queryDescription,
  priority,
}) {
  const subject = `New message from ${name}, (Priority: ${priority})`;
  const body = `
  <p><strong>Name:</strong> ${name}</p>
  <p><strong>Organization:</strong> ${organization}</p>
  <p><strong>Query Type:</strong> ${queryType}</p>
  <p><strong>Priority:</strong> ${priority}</p>
  <p><strong>Email:</strong> ${fromEmail}</p>
  <p><strong>Description:</strong><br/>
     ${queryDescription.replace(/\n/g, "<br/>")}
  </p>
`.trim();

  const resp = await fetch(
    `/api/organization/send_email_via_queryloop_support`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: "support@queryloop.ai", subject, body }),
    }
  );

  if (!resp.ok) throw new Error((await resp.json()).error || resp.statusText);
  return await resp.json();
}
